module.exports = {
  state: {
    appName: 'Application Name',
  },
};
